import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from '@mui/material';
import { Icon } from './icon';
export const CounterStrip = t0 => {
  const $ = _c(14);
  const {
    label,
    count,
    hideSubdirectoryIcon
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      justifyContent: "space-between",
      alignItems: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      alignItems: "center",
      gap: "8px"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== hideSubdirectoryIcon) {
    t3 = !hideSubdirectoryIcon && <Icon iconClass="material-symbols-subdirectory-arrow-right-rounded" />;
    $[2] = hideSubdirectoryIcon;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== label) {
    t4 = <Typography variant="subtitle1">{label}</Typography>;
    $[4] = label;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <Stack direction="row" sx={t2}>{t3}{t4}</Stack>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== count) {
    t6 = <Typography variant="subtitle1">{count}</Typography>;
    $[9] = count;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <Stack direction="row" sx={t1}>{t5}{t6}</Stack>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};